import React, { useEffect, useState } from 'react';

import { IntlProvider } from 'react-intl';

import English from '../lang/en.json';
import French from '../lang/fr.json'

export const Context = React.createContext();

const languages = {
    "en-GB": English,
    "fr-FR": French,
};

const LanguageWrapper = (props) => {
    const storedLocale = localStorage.getItem('locale');
    let defaultLocale = navigator.language;
    const fallbackLocale = 'en-GB';
    const [locale, setLocale] = useState(storedLocale || defaultLocale);

    useEffect(() => {
        const baseLocale = locale.split('-')[0];
        const supportedLocale = Object.keys(languages).find(lang => lang.startsWith(baseLocale)) || fallbackLocale;
        setLocale(supportedLocale);
        localStorage.setItem('locale', supportedLocale);
    }, [locale]);

    const messages = languages[locale];

    const selectLanguage = (e) => {
        const newLocale = e.target.value;
        setLocale(newLocale);
    };

    return (
        <Context.Provider value={{ locale, selectLanguage }}>
            <IntlProvider messages={messages} locale={locale}>
                {props.children}
            </IntlProvider>
        </Context.Provider>
    );
};

export default LanguageWrapper;